import { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight, Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { CONTACT } from "../data/content";
import { Footer } from "./Footer";
import { MobileBar } from "./MobileBar";

export const PAGE_NAV = [
    { to: "/heckenschnitt-celle", label: "Heckenschnitt" },
    { to: "/hochdruckreinigung-celle", label: "Hochdruckreinigung" },
    { to: "/rasenpflege-celle", label: "Rasenpflege" },
    { to: "/gartenpflege-celle", label: "Gartenpflege" },
    { to: "/referenzen", label: "Referenzen" },
    { to: "/ueber-mich", label: "Über mich" },
];

export const PageLayout = ({ children }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="min-h-screen bg-paper font-sans text-ink">
            <header className="fixed top-0 left-0 right-0 z-50 bg-white/85 backdrop-blur-xl border-b border-forest/10 shadow-[0_1px_24px_rgba(11,18,14,0.06)]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-[72px] flex items-center justify-between">
                    <Link to="/" data-testid="page-logo-home" aria-label="Zur Startseite">
                        <img src="/logo-forest.png" alt="Julians Gartenservice" className="h-10 w-auto" />
                    </Link>
                    <nav className="hidden xl:flex items-center gap-6">
                        {PAGE_NAV.map((n) => (
                            <Link
                                key={n.to}
                                to={n.to}
                                data-testid={`page-nav-${n.to.slice(1)}`}
                                className="text-sm font-medium tracking-tight text-shade hover:text-forest transition-colors duration-200"
                            >
                                {n.label}
                            </Link>
                        ))}
                    </nav>
                    <div className="flex items-center gap-3">
                        <a
                            data-testid="page-phone-link"
                            href={CONTACT.phoneHref}
                            className="hidden md:flex items-center gap-2 text-sm font-semibold text-forest hover:text-leaf transition-colors duration-200"
                        >
                            <Phone size={15} strokeWidth={2.4} />
                            {CONTACT.phoneDisplay}
                        </a>
                        <Link
                            to="/angebot"
                            data-testid="page-cta-quote"
                            className="hidden sm:flex items-center gap-2 bg-leaf hover:bg-forest text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors duration-200"
                        >
                            Angebot anfragen
                            <ArrowRight size={15} strokeWidth={2.4} />
                        </Link>
                        <button
                            data-testid="page-menu-toggle"
                            onClick={() => setOpen(!open)}
                            aria-label="Menü öffnen"
                            className="xl:hidden w-10 h-10 flex items-center justify-center rounded-full text-ink"
                        >
                            {open ? <X size={22} /> : <Menu size={22} />}
                        </button>
                    </div>
                </div>
                <AnimatePresence>
                    {open && (
                        <motion.nav
                            initial={{ opacity: 0, y: -8 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -8 }}
                            transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
                            className="xl:hidden bg-white/97 backdrop-blur-xl border-b border-hairline shadow-xl"
                            data-testid="page-mobile-menu"
                        >
                            <div className="px-6 py-6 flex flex-col gap-1">
                                <Link to="/" onClick={() => setOpen(false)} className="text-lg font-display font-medium text-ink py-3 border-b border-hairline">
                                    Startseite
                                </Link>
                                {PAGE_NAV.map((n) => (
                                    <Link
                                        key={n.to}
                                        to={n.to}
                                        onClick={() => setOpen(false)}
                                        className="text-lg font-display font-medium text-ink py-3 border-b border-hairline last:border-0"
                                    >
                                        {n.label}
                                    </Link>
                                ))}
                                <Link
                                    to="/angebot"
                                    onClick={() => setOpen(false)}
                                    className="mt-4 flex items-center justify-center gap-2 bg-leaf text-white font-semibold px-5 py-3.5 rounded-full"
                                >
                                    Kostenloses Angebot anfragen
                                    <ArrowRight size={16} />
                                </Link>
                            </div>
                        </motion.nav>
                    )}
                </AnimatePresence>
            </header>
            <main>{children}</main>
            <Footer />
            <MobileBar />
        </div>
    );
};
